// src/App.tsx
import { Suspense } from "react";
import { Routes } from "@/routes";
import { Toaster } from "@/components/ui/toaster";
import { LoadingPage } from "@/components/common/loading";

function App() {
  return (
    <>
      <Suspense fallback={<LoadingPage />}>
        <Routes />
      </Suspense>
      <Toaster />
    </>
  );
}

export default App;
